// extracted by css-extract-rspack-plugin
export default {"reason":"readonly-comment-box-module__reason__DQJKT"};